import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonHelpersService } from './common-helpers.service';
import { CookieHelperService } from './cookie-helper.service';
import { WpAjaxService } from './wp-ajax/wp-ajax.service';
import { PaginationService } from './pagination/pagination.service';
import { PostRequestsService } from './post-requests.service';
import { VehicleService } from './vehicles/vehicle.service';
import { AddressService } from './address/address.service';
import { SelectedOfferService } from './selected-offer.service';
import { GAPCalculator } from './gap-calculator';
import { DealersService } from './dealers/dealers.service';
import { WfsDirectAjaxService } from './wfs-direct-ajax.service';
import { SessionHelperService } from './session-helper.service';
import { AutoLoanService } from './auto-loans/auto-loan.service';
import { PDFGeneratorService } from './auto-loans/pdf-generator.service';
import { SettingsService } from './auto-loans/settings.service';
import { CaptchaService } from './captcha.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
  ],
  providers: [
    AutoLoanService,
    CommonHelpersService,
    SessionHelperService,
    CookieHelperService,
    WpAjaxService,
    VehicleService,
    PaginationService,
    AddressService,
    PostRequestsService,
    SelectedOfferService,
    GAPCalculator,
    DealersService,
    SettingsService,
    WfsDirectAjaxService,
    PDFGeneratorService,
    CaptchaService,
  ]
})
export class ServicesModule { }



// WEBPACK FOOTER //
// ./src/app/shared/services/services.module.ts